module.exports = __webpack_public_path__ + "img/take-back-control.df4a6fcf.png";